import { InjectionToken } from '@angular/core';

import { FeatureSpec } from '@recruitee/http/types';

export type FeatureSpecEntity = FeatureSpec[];

export type FeatureSpecFetchResponse = {
  features: FeatureSpec[];
};

export const FEATURE_SPEC = new InjectionToken<FeatureSpec[]>('FEATURE_SPEC');
